export default __webpack_public_path__ + "static/media/meetups-thumb-02.9cbb2f45.jpg";